export const Teams = [
  {
    id: 1,
    teamName: "Boston Bruins",
    nickname: "Bruins",
    sport: "Football",
    league: "NHL",
    triCode: "BOS",
    players: 25,
    country: "England",
    logo: "/assets/images/boston.png",
    city: "Boston",
  },
  {
    id: 2,
    teamName: "Boston Bruins",
    nickname: "Bruins",
    sport: "Hockey",
    league: "NHL",
    triCode: "BOS",
    players: 25,
    country: "USA",
    logo: "/assets/images/boston.png",
    city: "Boston",
  },
  {
    id: 3,
    teamName: "Boston Bruins",
    nickname: "Bruins",
    sport: "Hockey",
    league: "NHL",
    triCode: "BOS",
    players: 25,
    country: "Canada",
    logo: "/assets/images/boston.png",
    city: "Boston",
  },
  {
    id: 4,
    teamName: "Boston Bruins",
    nickname: "Bruins",
    sport: "Hockey",
    league: "NHL",
    triCode: "BOS",
    players: 25,
    country: "Australia",
    logo: "/assets/images/boston.png",
    city: "Boston",
  },
];
